import { useMemo } from 'react'
import BigNumber from 'bignumber.js'
import { PLSX } from '@pulsex/tokens'
import { ChainId } from '@pulsex/chains'
import { BIG_ZERO } from '@pulsex/utils/bigNumber'
import { useBalance, useReadContract } from '@pulsex/wagmi'
import { Address, erc20Abi } from 'viem'
import { useAccount } from 'wagmi'
import { useActiveChainId } from './useActiveChainId'

const useTokenBalance = (tokenAddress: Address, forcePulseChain?: boolean) => {
  const { address: account } = useAccount()
  const { chainId } = useActiveChainId()

  const { data, status, refetch, ...rest } = useReadContract({
    chainId: forcePulseChain ? ChainId.PULSECHAIN : chainId,
    abi: erc20Abi,
    address: tokenAddress,
    functionName: 'balanceOf',
    args: [account || '0x'],
    query: {
      enabled: !!account,
    },
    watch: true,
  })

  return {
    ...rest,
    refetch,
    fetchStatus: status,
    balance: useMemo(() => (typeof data !== 'undefined' ? new BigNumber(data.toString()) : BIG_ZERO), [data]),
  }
}

export const useGetPlsBalance = () => {
  const { address: account } = useAccount()
  const { chainId } = useActiveChainId()
  const { status, refetch, data } = useBalance({
    chainId,
    address: account,
    query: {
      enabled: !!account,
    },
    watch: true,
  })

  return { balance: data?.value ? BigInt(data.value) : 0n, fetchStatus: status, refresh: refetch }
}

export const useGetPlsxBalance = () => {
  const { chainId } = useActiveChainId()
  const { balance, fetchStatus } = useTokenBalance(PLSX[chainId].address, false)

  return { balance: BigInt(balance.toString()), fetchStatus }
}

export default useTokenBalance
